export default {"src":"/_next/static/media/offerIcon.79520f54.svg","height":16,"width":16};